import React, { useEffect, useState } from 'react';
import { PageLoader } from 'utils';
import Content from './content';
import Animation from './animation';
import Support from './support';

import styles from './index.module.scss';

function Login() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const threeScript = document.createElement('script');
        threeScript.setAttribute('id', 'threeScript');
        threeScript.setAttribute(
            'src',
            'https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js'
        );
        document.getElementsByTagName('head')[0].appendChild(threeScript);
        return () => {
            if (threeScript) {
                threeScript.remove();
            }
        };
    }, []);

    useEffect(() => {
        if (window.THREE && loading) setLoading(false);
    }, [window.THREE]);

    return (
        <div>
            <div
                className={styles.wrapper}
                style={{ opacity: !loading ? 1 : 0, zIndex: loading ? 1 : 20 }}
            >
                <Animation />
                <Content />
                <Support />
            </div>
            <div className={styles.loader} style={{ opacity: loading ? 1 : 0 }}>
                <PageLoader />
            </div>
        </div>
    );
}

export default Login;
